// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4241":"d3604a70","7220":"aa2a41b6"}[chunkId] + ".css";
};